import AvatarPlaceholder from '../../../components/common/AvatarPlaceholder';
import { CommonAvatar } from '../../../types';
import MessageAvatarList from './MessageAvatarList';
import { useTranslation } from 'react-i18next';
import { format, isToday, parseISO } from 'date-fns';

const MessageThreadHeader = (props: {
  time: string;
  avatars: CommonAvatar[];
  from: Array<string>;
}) => {
  const formattedFrom = props.from.map((f) => f.trim()).join(', ');
  const hasMultipleAvatars = props.from?.length > 1;
  const { t } = useTranslation();

  const avatarSize = '56px';

  const displayDate = (timestamp: string) =>
    isToday(parseISO(timestamp)) ? t('Today') : format(parseISO(timestamp), 'MMM dd, yyyy');

  return (
    <div className='message__thread__header'>
      <div style={{ display: 'flex' }}>
        {!props.avatars || props.avatars.length === 0 ? (
          <AvatarPlaceholder
            stringToUse={formattedFrom}
            style={{ width: '56px', height: '56px' }}
          />
        ) : (
          <MessageAvatarList
            avatars={props.avatars}
            width={avatarSize}
            height={avatarSize}
            style={{ fontSize: '24px', lineHeight: '22px' }}
            nameList={props.from}
          />
        )}
        <div
          className={`message__thread__header-container ${
            hasMultipleAvatars ? 'message__thread__header-container--alt' : ''
          }`}
        >
          <p
            className={`message__thread__header-full-name${hasMultipleAvatars ? '-multiple' : ''}`}
          >
            {t(formattedFrom)}
          </p>
          <p
            className={`message__thread__header-last-reply${hasMultipleAvatars ? '-multiple' : ''}`}
          >
            {displayDate(props.time)} - {format(parseISO(props.time), 'hh:mm a')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MessageThreadHeader;
